import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  FaUniversity,
  FaCreditCard,
  FaTags,
  FaBuilding,
  FaChartLine,
  FaCogs,
  FaArrowRight,
  FaWallet,
  FaDesktop,
  FaRegCreditCard,
  FaLayerGroup,
  FaTag
} from 'react-icons/fa';

const Cadastros = () => {
  const navigate = useNavigate();

  const handleNavigate = (path) => {
    navigate(path);
  };

  const cards = [
    {
      title: 'Configurações',
      description: 'Configure categorias e centros de custo para comandas e comissões',
      icon: FaCogs,
      path: '/financeiro/cadastros/configuracoes',
      active: true,
      color: '#6c757d',
      bgColor: 'rgba(108, 117, 125, 0.1)'
    },
    {
      title: 'Bancos',
      description: 'Cadastre e gerencie bancos do sistema',
      icon: FaUniversity,
      path: '/financeiro/cadastros/bancos',
      active: true,
      color: '#198754',
      bgColor: 'rgba(25, 135, 84, 0.1)'
    },
    {
      title: 'Contas',
      description: 'Gerencie contas bancárias e financeiras',
      icon: FaWallet,
      path: '/financeiro/cadastros/contas',
      active: true,
      color: '#fd7e14',
      bgColor: 'rgba(253, 126, 20, 0.1)'
    },
    {
      title: 'Categorias',
      description: 'Organize transações por categorias',
      icon: FaTags,
      path: '/financeiro/cadastros/categorias-financeiras',
      active: true,
      color: '#6f42c1',
      bgColor: 'rgba(111, 66, 193, 0.1)'
    },
    {
      title: 'Taxas Cartões',
      description: 'Cadastre e gerencie taxas de cartões de débito e crédito',
      icon: FaRegCreditCard,
      path: '/financeiro/cadastros/cartoes',
      active: true,
      color: '#20c997',
      bgColor: 'rgba(32, 201, 151, 0.1)'
    },
    {
      title: 'Sub-lançamentos',
      description: 'Configure sub-lançamentos automáticos por categoria',
      icon: FaLayerGroup,
      path: '/financeiro/cadastros/sublancamentos',
      active: true,
      color: '#e83e8c',
      bgColor: 'rgba(232, 62, 140, 0.1)'
    },
    {
      title: 'Centro de Custos',
      description: 'Controle custos por centro de responsabilidade',
      icon: FaBuilding,
      path: '/financeiro/cadastros/centros-de-custo',
      active: true,
      color: '#0d6efd',
      bgColor: 'rgba(13, 110, 253, 0.1)'
    },
    {
      title: 'Maquininhas',
      description: 'Cadastre e gerencie suas maquininhas de pagamento',
      icon: FaCreditCard,
      path: '/financeiro/cadastros/maquininhas',
      active: true,
      color: '#17a2b8',
      bgColor: 'rgba(23, 162, 184, 0.1)'
    },
    {
      title: 'Grupos DRE',
      description: 'Configure grupos para demonstração de resultados',
      icon: FaChartLine,
      path: '/financeiro/cadastros/grupos-dre',
      active: true,
      color: '#dc3545',
      bgColor: 'rgba(220, 53, 69, 0.1)'
    },
    {
      title: 'Tags',
      description: 'Crie tags para organizar seus lançamentos financeiros',
      icon: FaTag,
      path: '/financeiro/cadastros/tags',
      active: true,
      color: '#6610f2',
      bgColor: 'rgba(102, 16, 242, 0.1)'
    }
  ];

  return (
    <div className="container-fluid">
      <div className="card">
        <div className="card-body">
          <div className="row mt-3">
            <div className="col-12">
              <h4 className="fw-bold mb-0">
                Cadastros Financeiros
              </h4>
            </div>
          </div>
          <div className="row mt-4 mb-4">
            {cards.map((card, index) => {
              const IconComponent = card.icon;
              return (
                <div key={index} className="col-lg-4 col-md-6 col-sm-12 mb-4">
                  <div 
                    className={`card h-100 cadastro-card ${card.active ? 'active' : 'disabled'}`}
                    style={{ 
                      cursor: card.active ? 'pointer' : 'not-allowed',
                      borderRadius: '12px',
                      overflow: 'hidden',
                      border: '1px solid #e0e0e0',
                      opacity: card.active ? 1 : 0.6,
                      transition: 'all 0.3s ease'
                    }}
                    onClick={() => card.active && handleNavigate(card.path)}
                    onMouseEnter={(e) => {
                      if (card.active) {
                        e.currentTarget.style.transform = 'translateY(-4px)';
                      }
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)';
                    }}
                  >
                    <div className="card-body p-4">
                      <div className="d-flex align-items-center mb-3">
                        <div style={{ 
                          backgroundColor: card.bgColor, 
                          width: '70px', 
                          height: '70px',
                          minWidth: '70px',
                          borderRadius: '12px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          marginRight: '20px'
                        }}>
                          <IconComponent size={32} style={{ color: card.color }} />
                        </div>
                        <div className="flex-grow-1">
                          <h5 className="card-title fw-bold mb-2">{card.title}</h5>
                        </div>
                      </div>
                      
                      <div className="d-flex justify-content-between align-items-end">
                        <p className="card-text text-muted mb-0 flex-grow-1">
                          {card.description}
                        </p>
                        {card.active && (
                          <div className="d-flex align-items-center text-primary ms-3">
                            <span className="me-2">Acessar</span>
                            <FaArrowRight 
                              size={14} 
                              style={{ 
                                transition: 'transform 0.3s ease'
                              }} 
                              className="arrow-icon"
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Cadastros; 